<template>
  <!-- Page Content -->
  <div id='page-wrapper'>
    <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
    <div class='container-fluid'>
      <div class='row'>
        <div class='col-lg-12'>
          <h1 class='page-header'>تحويل بضاعة لفرع آخر</h1>
        </div>
        <!-- /.col-lg-12 -->
      </div>
      <!-- /.row -->
      <div class='row'>
        <div class='col-lg-12'>
          <div class='panel panel-default'>
            <div class='panel-heading'>
          هنا يتم عرض  تحويلات البضاعة للفروع الأخرى
            </div>
            <!-- /.panel-heading -->
            <div class='panel-body'>
              <div class='alert alert-danger alert-dismissable' v-if='mainValidationErrors'>
                <ul v-if='mainValidationErrors'>
                    <li v-for='err in mainValidationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                </ul>
              </div>
              <div class='col-lg-12' style="margin:0px;padding:0px">
                <div class='col-lg-3 col-md-3 col-sm-3' style="padding: 5px 5px">
                      <label>من فرع</label>
                      <select class="form-control"  v-model="from_branch_id">
                        <option v-for="item in branches" v-bind:key="item.id" v-bind:value="item.id">
                          {{ item.name }}
                        </option>
                      </select>
                </div>
                <div class='col-lg-3 col-md-3 col-sm-3' style="padding: 5px 5px">
                      <label>الى فرع</label>
                      <select class="form-control"  v-model="to_branch_id">
                        <option v-for="item in allBranches" v-bind:key="item.id" v-bind:value="item.id">
                          {{ item.name }}
                        </option>
                      </select>
                </div>
                <div class='col-lg-2 col-md-2 col-sm-3' style="padding: 5px 5px">
                  <tbDate  :mytitle='fromTitle' v-model= 'date_from' ></tbDate>
                </div>
                <div class='col-lg-2 col-md-2 col-sm-3' style="padding: 5px 5px">
                  <tbDate  :mytitle='toTitle' v-model= 'date_to' ></tbDate>
                </div>
                <div class='form-group col-lg-2 col-sm-2' style="padding: 5px 5px">
                  <label>النوع:</label>
                  <select class="form-control" style="padding: 0px" v-model="status">
                    <option v-for="type in types" v-bind:key="type.id" v-bind:value="type.id">
                      {{ type.name }}
                    </option>
                  </select>
                </div>
                <div class='col-lg-12 col-md-12 col-sm-12' style="padding: 0px 0px 15px 0px; text-align: center;">
                  <button @click='GetData()' type='button' class='btn btn-outline btn-primary btn-md'>
                    <b> عرض حسب الفلترة </b>
                  </button>
                  <button @click='GetNotPostedData()' type='button' class='btn btn-outline btn-primary btn-md'>
                    <b> عرض جميع الغير مرحل </b>
                  </button>
                </div>
              </div>
              <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                  <thead>
                    <tr>

                        <th style='text-align: center'>الى فرع</th>
                        <th style='text-align: center'>أمين المخزن</th>
                        <th style='text-align: center'>المحاسب</th>
                        <th style='text-align: center'>التاريخ</th>
                        <th style='text-align: center'>ملاحظات</th>
                        <th style='text-align: center'>الاجراء</th>
                    </tr>
                  </thead>
                  <tbody>
                      <tr class='odd gradeX' v-for='record in records' :key='record.id'>

                        <td align='center'>{{record.branch_to_name}}</td>
                        <td align='center'>{{record.storekeeper_from_name}}</td>
                        <td align='center' v-show="record.accountant_from_name">{{record.accountant_from_name}}</td>
                        <td align='center' v-show="!record.accountant_from_name">غير مرحل</td>
                        <td align='center'>{{record.date}}</td>
                        <td align='center'>{{record.notes_from}}</td>
                        <td align='center'>
                            <vue-element-loading size='32' :active='isLoadingDelete' spinner='bar-fade-scale' color='#A4A4A4'/>
                            <button @click='showForm(record)' type='button' class='btn btn-outline btn-info btn-xs' data-toggle='modal' data-target='#myModal'>عرض</button>
                          </td>
                      </tr>
                  </tbody>
              </table>
              <!-- /.table-responsive -->
            </div>
            <!-- /.panel-body -->
          </div>
          <!-- /.panel -->
        </div>
        <!-- /.col-lg-12 -->
      </div>
    </div>
    <!-- Modal -->
    <div class='modal fade' id='myModal' tabindex='-1' role='dialog'  aria-labelledby='myModalLabel' aria-hidden='true'>
      <div class='modal-dialog  modal-lg'>
        <div class='modal-content'>
          <div class='modal-header'>
            <button type='button' class='close' data-dismiss='modal' aria-hidden='true'>&times;</button>
            <h4 class='modal-title' id='myModalLabel'>ترحيل تحويل بضاعة لفرع آخر</h4>
          </div>
          <form role='form'>
            <div class='modal-body'>
              <div class='alert alert-danger alert-dismissable' v-if='errorShow'>
                <ul v-if='validationErrors'>
                  <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                </ul>
              </div>
              <div class='alert alert-success alert-dismissable' v-if='successShow'>
                {{success}}
              </div>
              <fieldset>
                <div class='form-group col-lg-3 col-md-3 col-sm-4'>
                  <label>الكود:</label> {{record.id}}
                </div>
                <div class='form-group col-lg-3 col-md-3 col-sm-4'>
                  <label>الى فرع:</label> {{record.branch_to_name}}
                </div>
                <div class='form-group col-lg-3 col-md-3 col-sm-4'>
                  <label>أمين المخزن:</label> {{record.storekeeper_from_name}}
                </div>
                <div v-show="record.accountant_from_name" class='form-group col-lg-3 col-md-3 col-sm-4'>
                  <label>المحاسب:</label> {{record.accountant_from_name}}
                </div>
                <div v-show="!record.accountant_from_name" class='form-group col-lg-3 col-md-3 col-sm-4'>
                  <label>المحاسب:</label> غير مرحل
                </div>
                  <div class='form-group col-lg-12 col-md-12 col-sm-12'>
                    <label>ملاحظات:</label> {{record.notes_from}}
                  </div>
                  <div v-show="parseInt(record.status) === 0" class='form-group col-lg-4 col-md-4  col-sm-12'   style="padding: 0px 5px 0px 5px">
                    <label>الصنف:</label>
                    <input @keypress="isLocked($event)" :value='alteredRec.item' class='form-control' name='invoic_id' type='text'>
                  </div>
                  <div v-show="parseInt(record.status) === 0" class='form-group col-lg-2 col-md-2  col-sm-4'   style="padding: 0px 5px 0px 5px">
                    <label>السعر:</label>
                    <input v-model='alteredRec.price' class='form-control' name='invoic_id' type='text'>
                  </div>
                  <div v-show="parseInt(record.status) === 0" class='form-group col-lg-2 col-md-2  col-sm-4'   style="padding: 0px 5px 0px 5px">
                    <label>الكمية:</label>
                    <input @keypress="isLocked($event)" :value='alteredRec.amount' class='form-control' name='invoic_id' type='text'>
                  </div>
                  <div v-show="parseInt(record.status) === 0" class='form-group col-lg-2 col-md-2  col-sm-4'   style="padding: 0px 5px 0px 5px">
                    <label>الاجمالى:</label>
                    <input @keypress="isLocked($event)" :value='alteredRec.total' class='form-control' name='invoic_id' type='text'>
                  </div>
                  <div v-show="parseInt(record.status) === 0" class='form-group col-lg-2 col-md-2  col-sm-4'   style="padding: 25px 5px 0px 5px">
                    <vue-element-loading size='32' :active='isLoadingSave' spinner='bar-fade-scale' color='#A4A4A4'/>
                    <button @click='saveItemData' type='button' class='btn btn-outline btn-primary btn-md btn-block'>حفظ السعر</button>
                  </div>

                  <table width='100%' class='table  table-bordered ' >
                    <thead>
                      <tr>
                        <th style='text-align: center'>م</th>
                        <th style='text-align: center'>الصنف</th>
                        <th style='text-align: center'>السعر</th>
                        <th style='text-align: center'>الكمية</th>
                        <th style='text-align: center'>الاجمالى</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr :class="{highlight :alteredRec.id == record.id}" v-for='(record, index) in invoiceItems' :key='record.id' v-on:click="showRec(record)">
                        <td style="padding:2px" align='center'>{{index +1}}</td>
                        <td style="padding:2px" align='right'>{{record.item}}</td>
                        <td style="padding:2px" align='right'>{{record.price}}</td>
                        <td style="padding:2px" align='center'>{{record.amount}}</td>
                        <td style="padding:2px" align='right'>{{record.total}}</td>
                      </tr>
                    </tbody>
                  </table>
                <div v-show="parseInt(record.status) === 0" class='col-lg-12 col-sm-12' style='padding: 0px;margin:0px'>
                  <div class='form-group col-lg-2 col-md-2  col-sm-4'   style="padding: 0px 5px 0px 5px">
                    <label>الاجمالى:</label>
                    <input @keypress="isLocked($event)" v-model='invoiceTotlas.total' class='form-control' name='invoic_id' type='text'>
                  </div>
                  <div class='form-group col-lg-2 col-md-2  col-sm-4'   style="padding: 0px 5px 0px 5px">
                    <label>الخصم:</label>
                    <input v-model='invoiceTotlas.discount' class='form-control' name='invoic_id' type='text'>
                  </div>
                  <div class='form-group col-lg-2 col-md-2  col-sm-4'   style="padding: 0px 5px 0px 5px">
                    <label>المضاف:</label>
                    <input v-model='invoiceTotlas.add' class='form-control' name='invoic_id' type='text'>
                  </div>
                  <div class='form-group col-lg-2 col-md-2  col-sm-4'   style="padding: 0px 5px 0px 5px">
                    <label>المطلوب:</label>
                    <input @keypress="isLocked($event)" v-model='invoiceTotlas.required' class='form-control' name='invoic_id' type='text'>
                  </div>
                  <div class='col-lg-4 col-sm-4' style='padding: 25px 0px 0px 10px;'>
                    <button @click='postInvoice' type='button' class='btn btn-outline btn-primary btn-md btn-block'>حفظ و ترحيل</button>
                  <vue-element-loading size='32' :active='isLoadingSave' spinner='bar-fade-scale' color='#A4A4A4'/>
                </div>
                </div>

              </fieldset>
            </div>
            <div class='modal-footer'>
              <button type='button' class='btn btn-default' data-dismiss='modal'>خروج</button>
            </div>
          </form>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
    <!-- /.container-fluid -->
  </div>
</template>
<style>
.highlight {
   background-color: #5A9EF5;
}
tr:hover{
   cursor: pointer;
}
</style>
<script>
import axios from 'axios'
import tbDate from '@/components/myComponents/tbDate'
export default {
  components: {
    tbDate
  },
  name: 'return_purchase_masters',
  data () {
    return {
      fromTitle: 'من',
      toTitle: 'إلى',
      date_from: '',
      date_to: '',
      dateVendoerTitle: 'تاريخ فاتورة المورد',
      dateTitle: 'تاريخ الفاتورة',
      validationErrors: '',
      stores: {},
      branches: {},
      allBranches: {},
      items: {},
      branch_id: '',
      records: {},
      record: {},
      alteredRec: {},
      invoiceItems: {},
      from_branch_id: '',
      to_branch_id: '',
      mainValidationErrors: '',
      errorShow: false,
      successShow: false,
      isLoadingData: false,
      isLoadingSave: false,
      isLoadingDelete: false,
      isLoadingDeleteItem: false,
      treasuries: {},
      amount: '',
      item_id: '',
      store_id: '',
      status: 0,
      types: [{id: 2, name: 'تم الاستلام'}, {id: 1, name: 'مرحل'}, {id: 0, name: 'غير مرحل'}],
      invoiceTotlas: ''
    }
  },
  mounted: function () {
    this.$watch('alteredRec', function () {
      if (this.alteredRec !== '') {
        this.alteredRec.total = (this.alteredRec.amount * this.alteredRec.price || 0)
      }
    }, {deep: true})
    this.$watch('invoiceTotlas', function () {
      if (this.invoiceTotlas !== '') {
        this.invoiceTotlas.required = ((parseFloat(this.invoiceTotlas.total || 0) + parseFloat(this.invoiceTotlas.add || 0)) - parseFloat(this.invoiceTotlas.discount || 0) || 0)
      }
    }, {deep: true})
  },
  created () {
    this.GetAllBranches()
    var today = new Date()
    var dd = String(today.getDate()).padStart(2, '0')
    var mm = String(today.getMonth() + 1).padStart(2, '0')
    var yyyy = today.getFullYear()
    today = dd + '-' + mm + '-' + yyyy
    this.date_from = today
    this.date_to = today
    this.branches = JSON.parse(localStorage.getItem('Branches'))
    this.items = JSON.parse(localStorage.getItem('Items'))
    this.branch_id = localStorage.getItem('BrancheID')
    this.from_branch_id = this.branch_id
    let i = this.branches.findIndex(x => x.id === parseInt(this.branch_id))
    if (i > -1) {
      this.treasuries = this.branches[i].treasuries
    }
    // this.GetData()
  },
  methods: {
    isNumber: function (evt) {
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    isLocked: function (evt) {
      evt.preventDefault()
    },
    GetAllBranches () {
      this.isLoadingData = true
      this.mainValidationErrors = ''
      axios.post(this.$apiURL + 'getBranches', {
        token: localStorage.getItem('token')
      })
        .then(({ data }) => {
          this.allBranches = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    },
    GetData () {
      this.isLoadingData = true
      this.mainValidationErrors = ''
      axios.post(this.$apiURL + 'getTransferBranchMasters', {
        token: localStorage.getItem('token'),
        from_branch_id: this.from_branch_id,
        to_branch_id: this.to_branch_id,
        date_from: this.date_from,
        date_to: this.date_to,
        status: this.status
      })
        .then(({ data }) => {
          this.records = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          this.mainValidationErrors = err.response.data.errors
          this.isLoadingData = false
        })
    },
    GetNotPostedData () {
      this.isLoadingData = true
      this.mainValidationErrors = ''
      axios.post(this.$apiURL + 'getAllTransferBranchNotPosted', {
        token: localStorage.getItem('token'),
        from_branch_id: this.from_branch_id
      })
        .then(({ data }) => {
          this.records = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          this.mainValidationErrors = err.response.data.errors
          this.isLoadingData = false
        })
    },
    getInvoiceItems () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getTransferBranchToPrice', {
        token: localStorage.getItem('token'),
        id: this.record.id
      })
        .then(({ data }) => {
          this.invoiceItems = data.TransferBranchItems
          this.invoiceTotlas = data.TransferBranchMasters
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    },
    showForm (recID) {
      this.errorShow = false
      this.successShow = false
      this.error = ''
      this.alteredRec = ''
      this.record = recID
      this.getInvoiceItems()
    },
    showRec (recID) {
      this.alteredRec = recID
    },
    saveItemData () {
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'saveTransferBranchItemPrice', {
        token: localStorage.getItem('token'),
        id: this.alteredRec.id,
        price: this.alteredRec.price
      })
        .then(res => {
          this.isLoadingSave = false
          this.invoiceItems = res.data.TransferBranchItems
          this.invoiceTotlas = res.data.TransferBranchMasters
          this.success = 'تم الحفظ بنجاح'
          this.successShow = true
          this.errorShow = false
        })
        .catch(err => {
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.successShow = false
          this.errorShow = true
          this.isLoadingSave = false
        })
    },
    postInvoice () {
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'saveTransferBranchInvoice', {
        token: localStorage.getItem('token'),
        id: this.record.id,
        discount: this.invoiceTotlas.discount,
        add: this.invoiceTotlas.add
      })
        .then(res => {
          this.isLoadingSave = false
          // let i = this.invoiceItems.map(record => record.id).indexOf(this.alteredRec.id)
          // this.invoiceItems.splice(i, 1, res.data.Purchases)
          // this.invoiceTotlas = res.data.purchaseMasters
          this.success = 'تم الحفظ بنجاح'
          this.successShow = true
          this.errorShow = false
        })
        .catch(err => {
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.successShow = false
          this.errorShow = true
          this.isLoadingSave = false
        })
    },
    saveInvoiceItem () {
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'saveReturnPurchases', {
        token: localStorage.getItem('token'),
        purchase_master_id: this.record.id,
        item_id: this.item_id,
        amount: this.amount,
        store_id: this.store_id
      })
        .then(res => {
          this.isLoadingSave = false
          this.invoiceItems.push(res.data)
          this.success = 'تم الحفظ بنجاح'
          this.successShow = true
          this.errorShow = false
          this.item_id = ''
          this.amount = ''
          this.$refs.item_id.focus()
        })
        .catch(err => {
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.successShow = false
          this.errorShow = true
          this.isLoadingSave = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/purchases/PosTransferBranch.vue